<template>
  <div
    class="Accordian flex flex-wrap w-full"
  >
    <div
      v-for="(slide, index) in dataComputed" :key="index"
      @click="selectSlide(slide, index)"
      class="cursor-pointer w-12 h-40 border-l border-black transition-all duration-500 ease-in-out flex items-start justify-start"
      :class="{
        'flex-1':slide.active
      }"
    >
      <div class="flex items-start h-full w-10">
        <p class="text-xs uppercase flex justify-end w-full transform -rotate-90 font-bold pr-2 whitespace-no-wrap">
          {{slide.name}}
        </p>
      </div>
    </div>
    <div class="w-full py-10 h-40">
      <div class="w-full" v-if="showNameInContent">
        <h4 class="leading-none">{{dataComputed[currentSlideIndex].name}}</h4>
      </div>
      <span class="leading-7" v-html="dataComputed[currentSlideIndex].content"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordian',
  props: {
    accordianData: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    showNameInContent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentSlideIndex: 0
    }
  },
  computed: {
    dataComputed () {
      var toReturn = []
      var listToLoop = this.accordianData
      for (var i = 0; i < listToLoop.length; i++) {
        if (this.currentSlideIndex === i) listToLoop[i].active = true
        else listToLoop[i].active = false

        toReturn.push(listToLoop[i])
      }
      return toReturn
    }
  },
  methods: {
    selectSlide (slide, index) {
      this.currentSlideIndex = index
      this.$emit('onClick', slide.name)
    }
  }
}
</script>

<style lang="scss">

</style>
